//https://github.com/greim/html-tokenizer

import EventEmitter from '../share/EventEmitter'
import defaultEntityMap from '../share/defaultEntityMap'

import chunk from './chunk'
import readAttribute from './readAttribute'
import States from './States'

import deentityify from './deentityify'

import helper from '../share/helper'

export default class extends EventEmitter {
  constructor(opts = {}) {
    super()

    this._running = false

    this._entityMap = helper.assign({}, defaultEntityMap, opts.entities)
  }

  cancel() {
    this._send("cancel")
  }

  entities(map) {
    helper.assign(this._entityMap, map)
  }

  _send(ev) {
    if (!this._running) {
      return
    }
    if (ev === 'text') {
      var text = arguments[1]
      if (this._text === undefined) {
        this._text = text
      } else {
        this._text += text
      }
    } else {
      if (this._text) {
        var deentText = deentityify(this._text, this._entityMap)
        this.emit('text', deentText)
        delete this._text
      }
      var len = arguments.length
      if (len === 1) {
        this.emit(ev)
      } else if (len === 2) {
        this.emit(ev, arguments[1])
      } else if (len === 3) {
        this.emit(ev, arguments[1], arguments[2])
      } else {
        this.emit.apply(this, arguments)
      }
    }
    if (ev === 'cancel') {
      delete this._running
    }
  }

  tokenize(html) {
    this._running = true
    this._send('start')
    var pos = 0
      , state = States.inText
      , currentTag
      , next
    while (pos < html.length) {
      if (state === States.inText) {
        var isBracket = html.charAt(pos) === '<' // cheap pre-emptive check
        if (isBracket && (next = chunk.getOpeningTag(html, pos))) {
          pos += next.length
          currentTag = next.match[2]
          this._send('opening-tag', currentTag)
          state = States.inTag
        } else if (isBracket && (next = chunk.getClosingTag(html, pos))) {
          pos += next.length
          this._send('closing-tag', next.match[2])
        } else if (isBracket && (next = chunk.getCommentOpen(html, pos))) {
          pos += next.length
          state = States.inComment
        } else if (next = chunk.getText(html, pos)) {
          pos += next.length
          this._send('text', next.match[1])
        } else {
          var text = html.substring(pos, pos + 1)
          pos += 1
          this._send('text', text)
        }
      } else if (state === States.inComment) {
        if (next = chunk.getComment(html, pos)) {
          pos += next.length
          this._send('comment', next.match[2])
          state = States.inText
        } else {
          this._send('comment', html.substring(pos))
          break
        }
      } else if (state === States.inScript) {
        if (next = chunk.getScript(html, pos)) {
          pos += next.length
          this._send('text', next.match[2])
          this._send('closing-tag', 'script')
          state = States.inText
        } else {
          this._send('text', html.substring(pos))
          break
        }
      } else if (state === States.inTag) {
        if (next = chunk.getAttributeName(html, pos)) {
          pos += next.length
          var name = next.match[2]
          var hasVal = next.match[4]
          if (hasVal) {
            var read = readAttribute(html, pos)
            pos += read.length
            this._send('attribute', name, deentityify(read.value, this._entityMap))
          } else {
            this._send('attribute', name, '')
          }
        } else if (next = chunk.getTagEnd(html, pos)) {
          pos += next.length
          var token = next.match[2]
          this._send('opening-tag-end', currentTag, token)
          state = currentTag === 'script' ? States.inScript : States.inText
        } else {
          state = States.inText
        }
      } else {
        break
      }
    }
    this._send('done')
    delete this._running
  }

}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/tokenizer/index.js